const PORTAL_HOST = process.env.REACT_APP_PORTAL_HOST || ''
export const STARGATE_BASE_PATH =
  window?.env?.stargateUrl.replace('$STARGATE_URL', '') || process.env.REACT_APP_STARGATE_HOST || ''

export const FETCH_RECENT_AND_CUSTOM_ORDERS = '/hcx/recent-custom-orders/'
export const HCP_REQUISITION_INFO = '/hcp/requisition-info/'
export const HCX_INIT = '/hcx/init/'
export const REFRESH_TOKEN_URL = '/auth/refresh_token'
export const LAUNCHPAD_PARTNERSHIPS = '/launchpad/partnerships'
export const ARCHIVE_CUSTOM_ORDER = '/hcx/custom-order-to-user/archive/'
export const UNARCHIVE_CUSTOM_ORDER = '/hcx/custom-order-to-user/unarchive/'

export const STARGATE_FEATURE_FLAGS = `/feature-flags`

// PAGES
export const CART_URL = '/cart'
export const LAUNCHPAD_URL = '/dashboard'
export const SPONSORED_TESTING = '/sponsored-testing'

export const HCX_ORDER = `${PORTAL_HOST}/hcx-order`
export const HCP_CLEAR_CART = '/hcp/clear-order/'
export const HCP_ORDER = `${PORTAL_HOST}/hcp/#/order`
export const HCP_ORDER_HISTORY_PAGE = `${PORTAL_HOST}/hcp/#/order-history/`
export const HCP_SETTINGS_PAGE = `${PORTAL_HOST}/hcp/#/settings/`
export const PORTAL_SIGN_IN = `${PORTAL_HOST}/en/profile/signin/`
export const PORTAL_SEARCH = (searchTerm: string) => `${PORTAL_HOST}/search?page=1&q=${searchTerm}`

export const PORTAL_URLS = {
  CATALOG: (categoryId: string) => `${PORTAL_HOST}/physician/category/${categoryId}`,
  FAMILY_URL: `${PORTAL_HOST}/us/family`,
  HEREDITARY_CANCER_MAIN_CATEGORY: `${PORTAL_HOST}/us/providers/test-catalog/hereditary-cancer/`,
  NIPS_CATALOG: `${PORTAL_HOST}/noninvasive-prenatal-screening/`,
  ONCOLOGY_MAIN_CATEGORY: `${PORTAL_HOST}/us/providers/test-catalog/oncology/`,
  PANELS_GENES: `${PORTAL_HOST}/physician/panelsgenes/`,
  PEDIATRIC_MAIN_CATEGORY: `${PORTAL_HOST}/us/providers/test-catalog/pediatric-and-rare-diseases/`,
  PHYSICIAN_SEARCH_URL: `${PORTAL_HOST}/en/physician/search/`,
  SEARCH_PAGE_URL: `${PORTAL_HOST}/en/search/`,
  SIGN_IN_URL: `${PORTAL_HOST}/en/profile/signin/`,
  SIGN_OUT_URL: `${PORTAL_HOST}/en/profile/signout/`,
  SIGN_UP_URL: `${PORTAL_HOST}/en/profile/signup/`,
  SPONSORED_TESTING_URL: `${PORTAL_HOST}/en${SPONSORED_TESTING}/`,
}
